<template>
  <a-modal
      title="回复客服信息"
      :width="860"
      v-model="visible"
      :confirm-loading="confirmLoading"
  >
    <a-form :form="form">
      <a-form-item
          label="客户建议/意见"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        {{ formData.content }}
      </a-form-item>
      <a-form-item
          label="上次回复时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        {{ formData.replyTime?formData.replyTime:'-' }}
      </a-form-item>

      <a-form-item
          label="回复"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        <a-textarea
            v-decorator="['reply', { rules: [{ required: true, message: '请输入回复！' }] }]"
            placeholder="输入回复" :rows="12" />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSubmit">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import suggestService from '../../service/suggest'
import moment from "moment";

export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      formData: {}
    }
  },
  methods: {
    showForm(formData) {
      this.form.resetFields()
      this.visible = true
      this.formData = formData

      this.$nextTick(() => {
        this.form.setFieldsValue({
          reply: formData.reply || ''
        })
      })
    },

    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          suggestService.reply({
            id: this.formData.id,
            reply: values.reply
          }).then((res) => {
            this.formData.reply = values.reply
            this.formData.replyTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
            this.formData.replyStatus = true
            this.formData.replyUserName = res.data.replyUserName
            this.confirmLoading = false

            this.$message.success('提交成功')
            this.$emit('reply')
            this.handleCancel()
          }).catch(() => {
            this.confirmLoading = false
          })
        }
      })
    },

    handleCancel() {
      this.visible = false
    }
  }
}
</script>